export interface SignState {
    value: number;
    label: string;
}

export interface IGetBillDetail {
    invoiceNumber: string; // 发票号码
    invoiceCode: string; // 发票代码
    invoiceTaxRate: number; // 税率 %
    amoutCent: string; // 价税合计 分
    checkStatus: string; // 申请状态
    invoiceBillingDate: number; // 开票日期 (秒)
}

export enum CREATE_STATUS {
    DOING = 0,
    HADDONE = 1,
}
export interface IGetBalanceDetail {
    ctime: string; // 提交时间
    startTimeUnix: string; // 单条记录的开始时间
    endTimeUnix: string; // 单条记录的截止时间
    status: CREATE_STATUS; // 状态，1：生成中，2：已生成
    s3Link?: string; // status为2时，下载链接
}

export interface PageReq {
    pageNo: number;
    pageSize: number;
}

export interface ITimeReq {
    startTime: number;
    endTime: number;
}

export interface ITimeReqV2 {
    startTimeUnix: number;
    endTimeUnix: number;
}

export interface PageReqV2 {
    pageNo: number;
    pageSize: number;
}

export interface IGetBalanceType {
    bizNo: number; // ID   用于查询提现详情使用
    successTime: number; // 时间
    bizType: number; // 类型
    bizTypeName: string; // 类型
    amountCent: string; // 金额大小（分）总金额 = amountCent * direction
    direction: number; // 金额正负  -1/1
    balanceCent: string; // 账户余额（分）
    status: number; // 状态:默认1成功
}

export interface IGetBillType {
    id: string; // 账单编号
    startTimeUnix: string; // 开始日期
    endTimeUnix: string; // 结束日期
    invoiceAmount: string; // 开票金额(分)
    totalAmount: string; // 账单总金额(分)
    invoiceStatus: string; // 账单状态 0：待审核，1：审核通过，2：审核驳回
    payBillId: string; // 付款单ID，查询发票使用
}

export interface IGetProvinceType {
    cityId: number;
    cityName: string;
}
export interface IGetCityType {
    cityId: number;
    cityList: IGetProvinceType[];
}

export interface IGetReceiptAddress {
    addressee: string; // 收件人
    phoneNumber: string; // 联系电话
    provinceName: string; // 省份名称
    provinceCode: string; // 省份城市code
    cityName: string; // 市名称
    cityCode: string; // 市城市code
    districtName: string; // 区名称
    districtCode: string; // 区code
    address: string; // 详细地址
}
